import { useMemo } from 'react';

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const MIN_AGE = 13;
const MAX_AGE = 100;

/** Month / day / year selects. Years run backwards from (this year − 13); no future years are offered. */
export function BirthdatePicker({ value, onChange }: { value: string | null; onChange: (iso: string | null) => void }) {
  const [y, m, d] = value ? value.split('-').map(Number) : [0, 0, 0];
  const thisYear = new Date().getFullYear();
  const years = useMemo(() => Array.from({ length: MAX_AGE - MIN_AGE + 1 }, (_, i) => thisYear - MIN_AGE - i), [thisYear]);
  const daysIn = (yy: number, mm: number) => (yy && mm ? new Date(yy, mm, 0).getDate() : 31);

  const set = (ny: number, nm: number, nd: number) => {
    if (!ny || !nm || !nd) { onChange(null); return; }
    const dd = Math.min(nd, daysIn(ny, nm));
    onChange(`${ny}-${String(nm).padStart(2, '0')}-${String(dd).padStart(2, '0')}`);
  };

  return (
    <div className="birthdate">
      <select value={m || ''} onChange={(e) => set(y, Number(e.target.value), d || 1)} aria-label="Month">
        <option value="">Month</option>
        {MONTHS.map((name, i) => <option key={name} value={i + 1}>{name}</option>)}
      </select>
      <select value={d || ''} onChange={(e) => set(y, m || 1, Number(e.target.value))} aria-label="Day">
        <option value="">Day</option>
        {Array.from({ length: daysIn(y, m) }, (_, i) => i + 1).map((n) => <option key={n} value={n}>{n}</option>)}
      </select>
      <select value={y || ''} onChange={(e) => set(Number(e.target.value), m || 1, d || 1)} aria-label="Year">
        <option value="">Year</option>
        {years.map((n) => <option key={n} value={n}>{n}</option>)}
      </select>
    </div>
  );
}
